/** Warm cream / gold chat shell (aligned with Explore Chaavi) */
export const CHAT_CHA = {
  pageBg: '#f5f1e8',
  shellBg: '#fffef9',
  border: 'rgba(139, 105, 20, 0.22)',
  gold: '#b8860b',
  goldDark: '#7a5c1a',
  goldMuted: 'rgba(184, 134, 11, 0.18)',
  goldPale: 'rgba(201, 162, 39, 0.22)',
  selectedBg: 'rgba(212, 184, 120, 0.32)',
  text: '#2e261c',
  textMuted: 'rgba(46, 38, 28, 0.62)',
  threadBg: '#faf8f5',
  emptyCircle: 'rgba(201, 162, 39, 0.2)',
} as const;
